<template>
  <div class="basic_wrap">
    
    <!-- 顶部导航 (自定义) -->
    <div class="custom_header">
      <div class="back_btn" @click="$router.back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </div>
      <div class="header_title">{{ $t('user.recharge') }}</div>
      <div class="record_btn" @click="$router.push('/recharge/record')">
        <img :src="require('../img/user/recharge.png')">
      </div>
    </div>

    <!-- ================= 主要内容区 ================= -->
    <div class="main_wrap">
      
      <!-- 1. 充值金额卡片 -->
      <div class="card_box">
        <div class="card_label">{{ $t('recharge.money') }}</div>
        <div class="amount_grid">
          <div 
            v-for="(v,i) in commonMoney" 
            :key="i"
            class="amount_item"
            :class="{ active_money: active_money == i }"
            @click="money = v; active_money = i;"
          >
           {{ v }}
          </div>
        </div>
      </div>

      <!-- 2. 其他充值金额卡片 -->
      <div class="card_box">
        <div class="card_label">{{ $t('recharge.anotherMoney') }}</div>
        <div class="custom_input_wrap">
          <span class="currency_prefix">{{ common.currency_symbol_basic() }}</span>
          <van-field 
            v-model="money" 
            type="number" 
            class="van_custom_input"
            :placeholder="$t('recharge.moneyMinPlaceholder') + minMoney"
          />
        </div>
      </div>

      <!-- 3. 充值方式卡片 -->
      <div class="card_box">
        <div class="card_label">{{ $t('recharge.method') }}</div>
        <div class="method_list">
          <div 
            v-for="(item, index) in rechargeMethod" 
            :key="index"
            class="method_item"
            :class="{ active_item: active == index }"
            @click="active = index"
          >
            <div class="method_left">
              <img :src="item.logo" class="method_icon">
              <span class="method_name">{{ item.name }}</span>
            </div>
            <div class="check_mark" :class="{ active_check: active == index }">
              <span>✓</span>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- ================= 底部悬浮操作区 ================= -->
    <div class="bottom_action_bar">
      <div class="balance_text">
        <div class="bal_label">{{ $t('recharge.money') }}</div>
        <div class="bal_amount">{{ common.currency_symbol_basic() }}{{ money || '0' }}</div>
      </div>
      <div 
        class="submit_btn"
        :class="money > 0 ? '' : 'disabled'"
        @click="submit"
      >
        {{ $t('recharge.rechargeNow') }}
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import { Field } from 'vant';
Vue.use(Field);

export default {
  name: "Recharge",
  data() {
    return {
      commonMoney: [],
      userBalance: '',
      money: '',
      rechargeMethod: [],
      active: 0,
      active_money: -1,
      minMoney: 0
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/getRechargeMethod').then(r => {
        this.userBalance = r.data.userBalance;
        this.commonMoney = r.data.commonMoney;
        this.rechargeMethod = r.data.rechargeMethod;
        this.minMoney = r.data.minMoney;
      })
    },
    submit() {
      if (this.money == "") {
        this.$toast(this.$t('recharge.moneyEmpty'));
        return false;
      }
      if (this.money <= 0) {
        this.$toast(this.$t('recharge.moneyError'));
        return false;
      }
      if (this.money - this.minMoney < 0) {
        this.$toast(this.$t('recharge.moneyMinError') + this.common.currency_symbol_basic() + this.minMoney);
        return false;
      }
      if (this.rechargeMethod[this.active]['type'] == 4) {
        this.$router.replace('/recharge/bank?money=' + this.money + "&id=" + this.rechargeMethod[this.active]['id']);
      } else {
        this.$router.replace('/recharge/qrcode?money=' + this.money + "&id=" + this.rechargeMethod[this.active]['id']);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  padding-bottom: 100px;
  min-height: 100vh;
  /* 浅蓝网格纹理背景 */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

/* ================= 顶部自定义导航 ================= */
.custom_header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #ffffff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e2e8f0;
  
  .back_btn {
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; width: 24px; height: 24px;
  }
  .header_title {
    font-size: 17px; font-weight: 700; color: #111;
  }
  .record_btn {
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    img { width: 22px; height: 22px; opacity: 0.7; }
  }
}

.main_wrap {
  padding: 16px;
}

/* ================= 通用白色卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
  border: 1px solid rgba(176, 202, 240, 0.3);

  .card_label {
    font-size: 14px; font-weight: 600; color: #1a2742; margin-bottom: 14px;
  }
}

/* ================= 1. 金额按钮网格 ================= */
.amount_grid {
  display: flex; flex-wrap: wrap; gap: 12px; justify-content: space-between;
  
  .amount_item {
    width: calc(33.33% - 8px);
    padding: 12px 0;
    background: #f8fafc; border: 1px solid #e2e8f0;
    border-radius: 12px; text-align: center;
    font-size: 14px; font-weight: 600; color: #1a2742;
    cursor: pointer; transition: all 0.15s;
    
    &:active { transform: scale(0.96); }
    &.active_money {
      background: #eff6ff; border-color: #2563eb; color: #2563eb;
    }
  }
}

/* ================= 2. 其他金额输入框 ================= */
.custom_input_wrap {
  display: flex; align-items: center;
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 12px; padding: 0 12px; height: 50px;

  .currency_prefix {
    font-size: 15px; font-weight: 700; color: #2563eb; margin-right: 8px;
  }
  .van_custom_input {
    flex: 1; padding: 0 !important; background: transparent !important;
    /deep/ .van-field__control {
      height: 50px; font-size: 15px; color: #1a2742;
      &::placeholder { color: #94a3b8; }
    }
  }
}

/* ================= 3. 充值方式列表 ================= */
.method_list {
  .method_item {
    display: flex; justify-content: space-between; align-items: center;
    border: 1px solid #e2e8f0; border-radius: 14px;
    padding: 14px 16px; margin-bottom: 12px;
    cursor: pointer; transition: all 0.2s;
    
    &:last-child { margin-bottom: 0; }
    
    &.active_item {
      border-color: #2563eb; background: #f5f9ff;
    }

    .method_left {
      display: flex; align-items: center; gap: 12px;
      .method_icon { width: 28px; height: 28px; border-radius: 50%; }
      .method_name { font-size: 15px; font-weight: 500; color: #1a2742; }
    }

    .check_mark {
      display: flex; align-items: center; justify-content: center;
      width: 22px; height: 22px; border-radius: 50%;
      background: #e2e8f0; color: #fff;
      font-size: 14px; font-weight: bold; transition: all 0.2s;
      
      &.active_check {
        background: #2563eb;
      }
    }
  }
}

/* ================= 4. 底部悬浮操作区 ================= */
.bottom_action_bar {
  position: fixed; bottom: 0; left: 0; right: 0;
  background: #ffffff; padding: 14px 16px;
  padding-bottom: calc(14px + constant(safe-area-inset-bottom));
  padding-bottom: calc(14px + env(safe-area-inset-bottom));
  box-shadow: 0 -4px 10px rgba(0,0,0,0.04);
  display: flex; justify-content: space-between; align-items: center;
  z-index: 100; border-top: 1px solid #f1f5f9;

  .balance_text {
    .bal_label { font-size: 12px; color: #64748b; }
    .bal_amount { font-size: 18px; font-weight: 800; color: #2563eb; }
  }

  .submit_btn {
    background: linear-gradient(135deg, #77a8ff 0%, #4e7dff 100%);
    color: #fff; padding: 12px 28px; border-radius: 24px;
    font-size: 15px; font-weight: 700; cursor: pointer;
    transition: all 0.15s; box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    &:active { transform: scale(0.96); }
    &.disabled { opacity: 0.6; cursor: not-allowed; pointer-events: none; }
  }
}
</style>